import { Component, OnInit, Input } from '@angular/core';
import {Hotel} from '../../api/model/hotel/hotel.model';

@Component({
    selector: 'stay-mgmt-hotel-info',
    templateUrl: './hotel-info.component.html',
    styleUrls: ['./hotel-info.component.scss']
})
export class HotelInfoComponent implements OnInit {
    @Input() messages;
    private _hotel: Hotel;
    showHotelBrandName = true;
    SP_BRANDS: string[] = ['SPND', 'SPCT', 'SP', 'ND', 'CT']

    constructor() {
    }
    @Input()
    set hotel(hotel: Hotel) {
      if (hotel) {
        this._hotel = hotel;
        this.setShowHotelBrandName();
      }
    }

    get hotel() {
      return this._hotel;
    }
    ngOnInit() {
    }

    setShowHotelBrandName() {
      if (!this.hotel.brandCode || this.SP_BRANDS.indexOf(this.hotel.brandCode.toUpperCase()) >= 0) {
        this.showHotelBrandName = false;
      }
    }
  }



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-info/hotel-info.component.ts